import Types from 'actions/types'
import Immutable from 'seamless-immutable'
import { combineReducers } from 'redux'

export const attempting = (state = Immutable(false), action) => {
  switch (action.type) {
    case Types.INVOICING_INVOICE_ADD_ATTEMPT:
      return true
    case Types.INVOICING_INVOICE_ADD_SUCCESS:
    case Types.SHOW_ADD_INVOICE_DIALOG:
    case Types.HIDE_ADD_INVOICE_DIALOG:
    case Types.INVOICING_INVOICE_ADD_FAILURE:
      return false
    default:
      return state
  }
}

export const error = (state = null, action) => {
  switch (action.type) {
    case Types.SHOW_ADD_INVOICE_DIALOG:
    case Types.HIDE_ADD_INVOICE_DIALOG:
    case Types.INVOICING_INVOICE_ADD_ATTEMPT:
    case Types.INVOICING_INVOICE_ADD_SUCCESS:
      return null
    case Types.INVOICING_INVOICE_ADD_FAILURE:
      return action.error
    default:
      return state
  }
}

export const defaultInvoiceCreateType = (state = null, action) => {
  switch (action.type) {
    case Types.SHOW_ADD_INVOICE_DIALOG:
      return state
    case Types.INVOICING_ADD_INVOICE_FOR_ORDER:
      return action.invoiceCreateType
    default:
      return state
  }
}

export default combineReducers({
  attempting,
  error,
  defaultInvoiceCreateType,
})
